import { Icon, SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { ExamDatesForLocationItem, ActionEnum } from './types';
import styled from '@emotion/styled';

interface PanelProps {
  date: ExamDatesForLocationItem;
  isEditable: boolean;
  onChange: () => void;
}

export const Panel = ({ date, isEditable, onChange }: PanelProps) => {
  const prop = getProps(date);

  return (
    <S.styledDiv
      panelColor={prop.panelColor}
      panelOpacity={prop.panelOpacity}
      isEditable={isEditable}
      onClick={() => isEditable && onChange()}
    >
      {prop.iconDetails ? (
        <Icon
          name={prop.iconDetails.icon}
          color={prop.iconDetails.color}
          inverted={prop.iconDetails.inverted}
        />
      ) : (
        ''
      )}
    </S.styledDiv>
  );
};

const getProps = (
  date: ExamDatesForLocationItem
): {
  panelColor?: string;
  panelOpacity?: number;
  iconDetails?: { icon: SemanticICONS; color?: SemanticCOLORS; inverted?: boolean };
} => {
  if (date === undefined) return {};

  if (date.action === ActionEnum.None && date.active)
    return { panelColor: '#b6e8c2', iconDetails: { icon: 'check', color: 'green' } };

  if (date.action === ActionEnum.Added && date.active)
    return {
      panelColor: '#4A90E2',
      iconDetails: { icon: 'check', inverted: true },
    };

  if (date.action === ActionEnum.Deleted && !date.active)
    return {
      panelColor: '#b6e8c2',
      panelOpacity: 0.5,
      iconDetails: { icon: 'remove', color: 'green' },
    };

  return {};
};

const S = {
  styledDiv: styled.div<{ panelColor?: string; panelOpacity?: number; isEditable: boolean }>`
    background-color: ${(props) => (props.panelColor ? props.panelColor : 'initial')};
    opacity: ${(props) => (props.panelOpacity ? props.panelOpacity : 'initial')};
    width: inherit;
    height: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    cursor: ${(props) => (props.isEditable ? 'pointer' : 'initial')};
  `,
};
